//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import EmptyCell from "../components/emptyCell";
import { getRoomsByMemberId } from "../../api/newOwner";

export default {
  name: "suggest",
  components: {
    EmptyCell,
    BottomNav,
  },
  data() {
    return {
      leftIco: require("@/assets/img/ico-building.png"),
      projectSelt: [
        // {
        //     leftIco: require('@/assets/img/ico-building.png'),
        //     project: '中粮鸿云',
        //     build: '06栋02单元501'
        // },
        // {
        //     leftIco: require('@/assets/img/ico-building.png'),
        //     project: '武汉大悦城',
        //     build: '32栋19单元1602'
        // }
      ],
      list: [],
      isShowCert: false,
      show: false,
    };
  },
  methods: {
    projectBlock(e) {
      if (e.cityName == "长沙市" ||  e.cityName == "株洲市") {
        this.show = true;
        return;
      } else {
        this.$router.push({ path: "/suggestForm/" + e.id });

        // :to="{ path: '/repairForm/' + item.id }"
      }
    },
    getOwners() {
      var memberId = localStorage.getItem("MemberId");
      if (!memberId) {
        return;
      }
      getRoomsByMemberId(parseInt(memberId))
        .then((res) => {
          this.list = [];
          this.list.push(...res.data.result);
          // this.totalCount = res.data.result.totalCount;
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    async getMyMember() {
      this.$toast.loading({
        duration: 0,
        message: "",
      });
      await this.$store
        .dispatch({
          type: "member/getMyMember",
        })
        .then(() => {
          this.member = this.$store.state.member.memberInfo;
          localStorage.setItem("MemberId", this.member.id);
          if (this.member && this.member.isAuthentication) {
            this.isShowCert = false;
            this.getOwners();
          } else {
            this.isShowCert = true;
          }
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    certificate() {
      this.$router.push({ path: "/character" });
    },
  },
  created() {
    this.getMyMember();
  },
};
